/**
 * 消息处理器：负责分类和处理不同类型的WebSocket消息
 */
class MessageHandler {
  constructor() {
    // 消息类型映射表，key为消息类型+目标地址，value为处理函数
    this.handlerMap = new Map();
    
    // 初始化默认处理器
    this.initDefaultHandlers();
  }
  
  /**
   * 初始化默认消息处理器
   */
  initDefaultHandlers() {
    // 系统通知消息处理器
    this.registerHandler('SYSTEM_NOTIFICATION', null, (payload) => {
      console.log('系统通知:', payload);
      // 可以在这里统一处理系统通知，如显示全局提示
      return {
        type: 'system',
        data: payload
      };
    });
    
    // 错误消息处理器
    this.registerHandler('ERROR', null, (payload) => {
      console.error('错误消息:', payload);
      return {
        type: 'error',
        data: payload
      };
    });
  }
  
  /**
   * 注册消息处理器
   * @param {string} messageType - 消息类型
   * @param {string} destination - 目标主题(可选)
   * @param {function} handler - 处理函数
   */
  registerHandler(messageType, destination, handler) {
    // 生成唯一键：消息类型+目标地址
    const key = this.generateKey(messageType, destination);
    if (typeof handler === 'function') {
      this.handlerMap.set(key, handler);
    } else {
      console.error('消息处理器必须是函数');
    }
  }
  
  /**
   * 处理消息
   * @param {object} message - 原始消息对象
   * @returns {object} 处理后的消息
   */
  handleMessage(message) {
    if (!message || !message.type) {
      console.error('无效的消息格式:', message);
      return null;
    }
    
    // 尝试匹配精确的处理器（类型+目标）
    let key = this.generateKey(message.type, message.destination);
    let handler = this.handlerMap.get(key);
    
    // 如果没有精确匹配，尝试只匹配类型
    if (!handler) {
      key = this.generateKey(message.type, null);
      handler = this.handlerMap.get(key);
    }
    
    // 如果有处理器则使用处理器处理，否则使用默认处理
    if (handler) {
      try {
        return handler(message.payload, message);
      } catch (error) {
        console.error(`处理消息失败 (${key}):`, error);
        return this.defaultHandler(message);
      }
    } else {
      return this.defaultHandler(message);
    }
  }
  
  /**
   * 默认消息处理器
   * @param {object} message - 原始消息对象
   * @returns {object} 处理后的消息
   */
  defaultHandler(message) {
    console.log('未处理的消息:', message);
    return {
      type: 'unhandled',
      originalType: message.type,
      destination: message.destination,
      data: message.payload
    };
  }
  
  /**
   * 生成处理器映射键
   * @param {string} messageType - 消息类型
   * @param {string} destination - 目标主题
   * @returns {string} 映射键
   */
  generateKey(messageType, destination) {
    return destination ? `${messageType}:${destination}` : messageType;
  }
  
  /**
   * 移除消息处理器
   * @param {string} messageType - 消息类型
   * @param {string} destination - 目标主题(可选)
   */
  removeHandler(messageType, destination) {
    const key = this.generateKey(messageType, destination);
    this.handlerMap.delete(key);
  }
}

// 导出单例实例
export default new MessageHandler();
